import { createPortal } from 'react-dom';

type VerifyingOverlayProps = {
  message?: string;
};

/** Non-dismissible loading dialog over a dimmed page (chooser JWT wait, etc.). */
export function VerifyingOverlay({ message = 'Verifying access…' }: VerifyingOverlayProps) {
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className="verifying-overlay" role="alertdialog" aria-modal="true" aria-busy="true" aria-live="polite">
      <div className="verifying-overlay__dialog">
        <div className="verifying-overlay__spinner" aria-hidden />
        <p className="verifying-overlay__message">{message}</p>
      </div>
    </div>,
    document.body,
  );
}
